module.exports = __webpack_public_path__ + "static/media/participants.b7c4844b.svg";